// src/api/auth.js
import API from "../axiosConfig";

export const getTicketParkingSearch = async (params) => {
  try {
    const response = await API.get("/ticket-parking", { params });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const calculateTicketParking = async (params) => {
  try {
    const response = await API.get("/calculate-ticket-detail", { params : params });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const calculateTicketExtension = async (ticketId, additionalMinutes) => {
  try {
    const response = await API.post("/ticket-parking/calculate-extension", {
      ticket_id: ticketId,
      additional_minutes: additionalMinutes,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const extendTicketParking = async (ticketId, additionalMinutes) => {
  try {
    const response = await API.post("/ticket-parking/extend", {
      ticket_id: ticketId,
      additional_minutes: additionalMinutes,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
